import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'order',
    serviceName: 'auth',
    query: gql`
      query getOrder($ids: [String], $for_admin: Int) {
        order(ids: $ids, for_admin: $for_admin) {
          data {
            order_details {
              id
              status
              number
              co_price
              me_price
              sync_status
              total_price
              discount_title
              discount_amount
              product_shop {
                id
                product_info {
                  id
                  title
                  barcode
                  introtext
                  brand {
                    title
                  }
                  media {
                    full_url
                  }
                }
              }
              attribute_values {
                title
                price_change_value
                attribute {
                  title
                }
              }
            }
          }
        }
      }
    `,
  },
};

export default schema;
